import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=c449438a&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"
import style0 from "./Archives.vue?vue&type=style&index=0&id=c449438a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c449438a",
  null
  
)

export default component.exports